export class User {
  username:string;
  balance:number;

  constructor(username:string, balance:number) {
    this.username = username;
    this.balance = balance;
  }
}



// WEBPACK FOOTER //
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/shared/domain/user.ts